// extracted by mini-css-extract-plugin
module.exports = {"headline":"headline_headline__a1zWZ","small":"headline_small__YwFGe","medium":"headline_medium__Uu2XW","large":"headline_large__CfFY8"};